<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import {useEvaluationFileModelStore} from "@/stores/Evaluation/EvaluationFileModel";
import axios from "axios";

export default {
    props: {
        value: [Number, Array],
        readonly: Boolean,
        multiple: Boolean,
        label: String,
        rules: Array,
    },
    emits: ["input", "change"],
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const evaluationFileModelStore = useEvaluationFileModelStore();

        const model = ref(null);

        function findAll() {
            loading.value  = true;
            axios.get(`/evaluationFileModels`).then(response => {
                evaluationFileModelStore.setEvaluationFileModels(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        function input(value) {
            emit('input', value)
        }

        function change() {
            emit('change')
        }

        watch(() => props.value, () => {
            model.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            evaluationFileModelStore,
            loading,
            inputColor,
            backgroundColor,
            model,
            input,
            change,
        }
    }
}
</script>

<template>
    <div>
        <v-autocomplete
            v-model="model"
            :items="evaluationFileModelStore.evaluationFileModels"
            item-value="id"
            item-text="name"
            outlined
            dense
            :label="label"
            :color="inputColor"
            :background-color="backgroundColor"
            :multiple="multiple"
            :readonly="readonly"
            :loading="loading"
            :clearable="!readonly"
            @input="input"
            @change="change"
            :rules="rules"
            hide-details="auto"
        />

        <input type="hidden">
    </div>
</template>

<style scoped>

</style>